"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "training",
  transform: "translate(-8 -56)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2171",
  "data-name": "Trac\xE9 2171",
  d: "M94.727,56H12.41A4.416,4.416,0,0,0,8,60.41v49.978a4.416,4.416,0,0,0,4.41,4.41H42.8l-2.1,7.35H34.459a1.47,1.47,0,0,0-1.47,1.47v2.94H21.23a1.47,1.47,0,0,0,0,2.94H85.908a1.47,1.47,0,0,0,0-2.94H74.148v-2.94a1.47,1.47,0,0,0-1.47-1.47H66.436l-2.1-7.35H94.727a4.416,4.416,0,0,0,4.41-4.41V60.41A4.416,4.416,0,0,0,94.727,56ZM71.208,125.088v1.47H35.929v-1.47Zm-27.45-2.94,2.1-7.35H61.28l2.1,7.35ZM96.2,110.388a1.472,1.472,0,0,1-1.47,1.47H12.41a1.472,1.472,0,0,1-1.47-1.47v-2.94H96.2Zm0-5.88H10.94V60.41a1.472,1.472,0,0,1,1.47-1.47H94.727a1.472,1.472,0,0,1,1.47,1.47Z",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2172",
  "data-name": "Trac\xE9 2172",
  d: "M175.04,115.363v-7.6a1.47,1.47,0,0,0-.849-1.332l-22.049-10.29a1.468,1.468,0,0,0-1.242,0l-22.049,10.29a1.47,1.47,0,0,0,0,2.664l7.971,3.719v17a1.47,1.47,0,0,0,1.47,1.47H164.75a1.47,1.47,0,0,0,1.47-1.47v-17l5.88-2.743v5.3a4.41,4.41,0,1,0,2.94,0Zm-11.76,12.976H139.761V114.183l11.139,5.2a1.468,1.468,0,0,0,1.242,0l11.139-5.2Zm-11.76-11.912-18.573-8.667,18.573-8.667,18.573,8.667Zm22.049,4.562a1.47,1.47,0,1,1,1.47-1.47A1.47,1.47,0,0,1,173.57,120.989Z",
  transform: "translate(-97.952 -32.65)",
  fill: "#fff"
}));
let viewBox = '0 0 91.137 73.498';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'EtudiantIcon', viewBox);
